module.exports = __webpack_public_path__ + "static/media/loader-white.c2bf937f.svg";